import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class SnailMailIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14"><path d="M6 0h3v3H6v1h9a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h2v5h1V0z"/></svg>
        )
    }
}

export default withCssClassName(SnailMailIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/snail-mail-icon.js